<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-fishingParadise">
      <div class="px-3 col-3 p-0">
        <div class="heading-fishingParadise">{{ $t("result.round") }}</div>
        <div class="text-subhead-fishingParadise">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-fishingParadise">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-fishingParadise">
          {{ data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-fishingParadise">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-fishingParadise">
          {{ (winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-fishingParadise">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-fishingParadise">
          {{ (balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-fishingParadise pt-3">
      <div class="text-games-fishingParadise">{{ "Fishing Paladise" }}</div>
      <div class="text-subgame-fishingParadise">{{ $t("fishingParadise.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>

      <div class="d-flex flex-row justify-content-center" style="margin-top: 40px;">
        <img v-if="winnings.length > 0" class="d-flex col-8 mb-4"
          :src="require(`../../assets/resultGame/fishingParadise/win.png`)" alt="" />
        <img v-else class="d-flex col-8 mb-4 lose" :src="require(`../../assets/resultGame/fishingParadise/lose.png`)"
          alt="" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-fishingParadise" @click="delCount()"></i>
        </div>

        <!-- <div class="d-flex col-10 table-fishingParadise container" /> -->

        <div class="d-flex flex-column">
          <div class="top-reel justify-content-center">
            <div class="" v-for="(row, index) in reels[6]" :key="index">
              <div style="position: relative; text-align: center;">
                <img class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/1/symbol_${row}.png`)
                  " alt="" />
                <div v-if="(reels[6][index] === 10 || reels[6][index] === 23 || reels[6][index] === 34)
                  && multiplierReel[6][index] > 0" class="multiplier-text ">
                  x3
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.newReel[0]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise"
                    :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)" alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0] - 13}.png`)"
                    alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="(reels[0][index] === 10 || reels[0][index] === 23 || reels[0][index] === 34)
                    && multiplierReel[0][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[1]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/fishingParadise/silver${reel[1]}.png`)" alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)" alt="" />
                  <!-- <div style="color:white">{{data.detail.reels[1]}}</div> -->
                  <div v-if="(reels[1][index] === 10 || reels[1][index] === 23 || reels[1][index] === 34)
                    && multiplierReel[1][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[2]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise"
                    :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)
                      " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="(reels[2][index] === 10 || reels[2][index] === 23 || reels[2][index] === 34)
                    && multiplierReel[2][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[3]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="(reels[3][index] === 10 || reels[3][index] === 23 || reels[3][index] === 34)
                    && multiplierReel[3][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[4]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="(reels[4][index] === 10 || reels[4][index] === 23 || reels[4][index] === 34)
                    && multiplierReel[4][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[5]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-fishingParadise" :src="require(`../../assets/resultGame/fishingParadise/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/fishingParadise/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="(reels[5][index] === 10 || reels[5][index] === 23 || reels[5][index] === 34)
                    && multiplierReel[5][index] > 0" class="multiplier-text ">
                    x3
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-fishingParadise" @click="addCount()"></i>
        </div>
      </div>

      <div class="text-center py-4 text-games-fishingParadise">
        <div class="text-subgame-fishingParadise">
          Multiplier X{{ this.multiplier }}
        </div>
        <h1 v-if="isFreespin">
          FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}
        </h1>
        <h1 v-else>SPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0 || data.detail.win > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-fishingParadise">
        Feature Buy
      </div>
      <br />
      <div class="col-12 justify-content-center d-flex flex-row">
        <div v-if="data.detail.win > 0" class="col-12 multiplier-box-fishingParadise align-items-center">
          <h1 class="my-1 green">
            {{ $t("fishingParadise.stack-multiplier") }} x{{ this.multiplier }}
          </h1>
          <h1 class="my-1 green"> {{ $t("fishingParadise.totalwin") }}
            {{ ((data.detail.win / this.multiplier)) | currencyFormatter }}
            x {{ this.multiplier }}
            = {{ (data.detail.win) | currencyFormatter }}
          </h1>
        </div>
        <div v-else-if="winnings.length > 0" class="col-12 multiplier-box-fishingParadise align-items-center">
          <h1 class="my-1 green">
            {{ $t("fishingParadise.multiplier-title") }} x{{ data.detail.spinRound }}
          </h1>
        </div>
      </div>
      <div v-if="winnings.length" class="col-12 justify-content-start d-flex flex-row">
        <div class=" p-2 px-3 justify-content-start align-items-center container">
          <div class="bet-wrapper justify-content-between item d-flex flex-row col-12"
            v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-fishingParadise"
                :src="require(`../../assets/resultGame/fishingParadise/1/symbol_${detail.symbol}.png`)" alt="" />
              <div style="margin-left:10px" class=" d-flex text-win align-items-center 
                            justify-content-center">
                <p class="my-1 green">{{ ` ${detail.row} ` + $t("result.kind") }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-fishingParadise",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      multiplierReel: this.data.detail.multiplierReels ? this.data.detail.multiplierReels : null,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      balance: 0,
      bet: 0,
      winlose: 0,
      isEndRound: false,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-fishingParadise")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";

      this.reels = result.reels;
      this.reelSizes = result.reelSizes;
      this.multiplierReel = result.multiplierReels;
      this.multiplier = result.multiplier;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.newReel = await this.mapTable(this.reels, this.reelSizes);

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #090349;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.lose {
  visibility: hidden;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.text-win {
  height: 90px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-fishingParadise {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-fishingParadise {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-fishingParadise {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-fishingParadise {
  /* background: #0c161f; */
  border-radius: 10px;
  /* min-height: 200px; */
  /* max-height: 300px; */
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-fishingParadise {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-fishingParadise {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-fishingParadise .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-fishingParadise .bet-wrapper-fishingParadise:not(:first-child) .item {
  margin-top: 10px;
  width: 800px;
}

.bet-wrapper-fishingParadise,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-fishingParadise {
  background: #072879;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-fishingParadise>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-fishingParadise {
  color: #FFFF;
  text-align: center;
}

.content-result-fishingParadise {
  background: #090349;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-fishingParadise {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-fishingParadise {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-fishingParadise {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-fishingParadise {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-fishingParadise {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-fishingParadise {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-100%, 0%);
  width: 100%;
  height: 100%;
}

.table-fishingParadise {
  background: url("~@/assets/resultGame/fishingParadise/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 764px 645px;
  /* set Bg Table HERE */
  width: 764px;
  height: 645px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 45px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -56px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 67%;
  transform: translate(24.5%, 0%);
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}



.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}

.text-multiplier {
  width: 500px;
}

@media screen and (max-width: 1030px) {
  .table-fishingParadise {
    background-size: 760px 640px;
    width: 760px;
    height: 640px;
    transform: translate(0px, -55px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-fishingParadise {
    min-width: 580px;
    max-width: auto;
    /* height: 280px; */
  }

  .bet-wrapper-fishingParadise {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-fishingParadise,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }
}

@media screen and (max-width: 900px) {
  .table-fishingParadise {
    background-size: 747px 645px;
    width: 747px;
    height: 645px;
    transform: translate(0px, -58px);
  }
}

@media screen and (max-width: 870px) {
  .table-fishingParadise {
    background-size: 729px 628px;
    width: 729px;
    height: 628px;
    transform: translate(-2px, -59px);
  }
}

@media screen and (max-width: 840px) {
  .table-fishingParadise {
    background-size: 699px 602px;
    width: 699px;
    height: 602px;
    transform: translate(0px, -57px);
  }
}

@media screen and (max-width: 800px) {
  .table-fishingParadise {
    background-size: 659px 569px;
    width: 659px;
    height: 569px;
    transform: translate(0px, -56px);
  }
}

@media screen and (max-width: 780px) {}

@media screen and (max-width: 770px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 638px 550px;
    width: 638px;
    height: 550px;
    margin-bottom: 1%;
    transform: translate(0px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 740px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 614px 526px;
    width: 614px;
    height: 526px;
    margin-bottom: 1%;
    transform: translate(0px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 710px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 582px 500px;
    width: 582px;
    height: 500px;
    margin-bottom: 1%;
    transform: translate(-2px, -54px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 680px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 566px 482px;
    width: 566px;
    height: 482px;
    margin-bottom: 1%;
    transform: translate(-1px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 650px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 543px 470px;
    width: 543px;
    height: 470px;
    margin-bottom: 1%;
    transform: translate(0px, -56px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 620px) {
  .heading-fishingParadise {
    font-size: 18px;
  }

  .table-fishingParadise {
    background-size: 516px 444px;
    width: 516px;
    height: 444px;
    margin-bottom: 1%;
    transform: translate(-2px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-fishingParadise {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-fishingParadise {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 600px) {
  .table-fishingParadise {
    background-size: 498px 430px;
    width: 498px;
    height: 430px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 570px) {
  .table-fishingParadise {
    background-size: 474px 410px;
    width: 474px;
    height: 410px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 540px) {
  .table-fishingParadise {
    background-size: 450px 390px;
    width: 450px;
    height: 390px;
    transform: translate(-1px, -54px);
  }

  .text-multiplier {
    width: 500px;
  }
}

@media screen and (max-width: 510px) {
  .table-fishingParadise {
    background-size: 425px 367px;
    width: 425px;
    height: 367px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-fishingParadise>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-fishingParadise {
    font-size: 12px;
  }

  .table-fishingParadise {
    background-size: 399px 344px;
    width: 399px;
    height: 344px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-fishingParadise {
    font-size: 14px;
  }

  .bet-box-fishingParadise {
    min-width: 230px;
    max-width: auto;
    /* height: 200px; */
  }

  .bonus-box-fishingParadise {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-fishingParadise {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-fishingParadise {
    width: 50px;
    height: 50px;
  }

  .text-win {
    height: 60px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-fishingParadise {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-fishingParadise>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-fishingParadise {
    font-size: 12px;
  }

  .table-fishingParadise {
    background-size: 375px 324px;
    width: 375px;
    height: 324px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-fishingParadise {
    font-size: 14px;
  }

  .bet-box-fishingParadise {
    min-width: 230px;
    max-width: auto;
    /* height: 200px; */
  }

  .bonus-box-fishingParadise {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-fishingParadise {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-fishingParadise {
    width: 50px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-fishingParadise {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 420px) {

  .table-fishingParadise {
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    transform: translate(1px, -52px);
  }
}

@media screen and (max-width: 390px) {

  .table-fishingParadise {
    background-size: 325px 280px;
    width: 325px;
    height: 280px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 360px) {

  .table-fishingParadise {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

}

@media screen and (max-width: 340px) {

  .table-fishingParadise {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }
}

@media screen and (max-width: 320px) {

  .table-fishingParadise {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }
}

.multiplier-text {
  font-size: 7vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -30%);
  color: #fff346;
  font-weight: 700;
  text-shadow: -1px -1px 0 #b33000,
    1px -1px 0 #b33000,
    -1px 1px 0 #b33000,
    1px 1px 0 #b33000;
}
</style>